import { render, staticRenderFns } from "./ClipboardWithDirective.vue?vue&type=template&id=c6529f96"
import script from "./ClipboardWithDirective.vue?vue&type=script&lang=js"
export * from "./ClipboardWithDirective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports